import {
  IRequestArgs,
  IResponseData,
  ListResponseData,
} from "@/utilities/types/requests.ts";
import { request } from "@/utilities/libs/request.ts";
import { ERequestMethods } from "@/utilities/enums/RequestMethod.ts";
import { E_API_KEY } from "@/utilities/enums/ApiKey.ts";
import { IApiKey, IApiKeyPayload } from "@/utilities/types/ApiKey.ts";

function getAPIKey({ queryParams }: IRequestArgs) {
  const query = {
    sort: { createdAt: "DESC" },
    ...queryParams?.pagination,
  };
  return request<ListResponseData<IApiKey>>({
    method: ERequestMethods.GET,
    url: E_API_KEY.MAIN,
    params: query,
  });
}

function postApiKey(data: IApiKeyPayload) {
  return request<IResponseData<IApiKey>>({
    method: ERequestMethods.POST,
    url: E_API_KEY.MAIN,
    data,
  });
}

function updateApiKey(id: string, data: IApiKeyPayload) {
  return request<IResponseData<IApiKey>>({
    method: ERequestMethods.PATCH,
    url: E_API_KEY.DETAIL.replace(":id", id),
    data,
  });
}

function deleteApiKey(id: string) {
  return request<IResponseData<IApiKey>>({
    method: ERequestMethods.DELETE,
    url: E_API_KEY.DETAIL.replace(":id", id),
  });
}

const APIKeyRepository = Object.freeze({
  getAPIKey,
  updateApiKey,
  postApiKey,
  deleteApiKey,
});

export default APIKeyRepository;
